import React from 'react';

// Resources
import logo from '../images/logo.png';

// MaterialUI
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

export default function Loader() {
	return (
		<React.Fragment>
			<AppBar
				color="primary"
				position="sticky"
				top={0}
				width="100%"
				sx={{
					zIndex: (theme) => theme.zIndex.drawer + 1,
					background: {
						md: 'linear-gradient(115deg, #0F1820 255px, #B1282E 300px)',
						xs: 'linear-gradient(115deg, #0F1820 85px, #B1282E 120px)'
					}
				}}
			>
				<Toolbar>
					<Grid container spacing={1} alignItems="center">
						<Grid sx={{ display: { md: 'block', xs: 'none' } }} item >
							<a href="/list"><img src={logo} alt="BTECH, Inc." style={{ height: "56px" }} /></a>
						</Grid>
						<Grid item xs alignItems="center">
							<Typography
								align="center"
								variant="h6"
								fontFamily='Saira,sans-serif'
								fontWeight='400'
								sx={{ flexGrow: 1}}
							>
								Online Battery Validation Manager
							</Typography>
						</Grid>
						<Grid item>
							<Avatar style={{ backgroundColor: 'green' }} />
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
			<Typography
				fontFamily='Saira, sans-serif'
				color='#0F1820'
				variant="h4"
				style={{
					fontWeight: 600,
					width: '100%',
					textAlign: 'center',
					marginTop: 10,
					paddingTop: 20,
				}}
			>
				Loading...
			</Typography>
			{/* Potentially add more to the page body here, though largely unnecessary */}
		</React.Fragment>
	);
}